import { Link, router, usePage } from '@inertiajs/react'

import { Container } from '@/components/container'
import { Logo } from '@/components/logo'
import { Button } from '@/components/ui/button'
import { dashboardPath, signOutPath } from '@/routes'

type AppShellProps = {
  children: React.ReactNode
  title?: string
}

export function AppShell({ children, title }: AppShellProps) {
  const { currentUser } = usePage().props

  return (
    <div className="bg-muted text-foreground flex min-h-screen flex-col">
      <div className="border-border bg-background border-b">
        <Container>
          <div className="flex items-center justify-between py-4">
            <Link href={dashboardPath()} className="hover:opacity-90">
              <Logo className="text-xl" />
            </Link>
            <div className="flex items-center gap-3">
              {title ? <span className="text-muted-foreground hidden text-sm sm:inline">{title}</span> : null}
              {currentUser ? (
                <>
                  <span className="text-muted-foreground hidden text-sm md:inline">{currentUser.name}</span>
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => router.delete(signOutPath())}
                  >
                    Sign out
                  </Button>
                </>
              ) : null}
            </div>
          </div>
        </Container>
      </div>
      <main className="overflow-y-auto p-4 md:p-8">{children}</main>
    </div>
  )
}
